import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
document.addEventListener('click', async function (event) {
  if (event.target.classList.contains('add-upsell')) {
    event.preventDefault();
    const button = event.target;
    const variantId = button.getAttribute('data-variant');

    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!res.ok) throw new Error('Add to cart failed');

      // Re-fetch cart contents
      const cartRes = await fetch('/?section_id=cart-drawer');
      const html = await cartRes.text();

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const newDrawer = tempDiv.querySelector('cart-drawer-component');

      if (newDrawer) {
        const currentDrawer = document.querySelector('cart-drawer-component');
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }

    } catch (err) {
      console.error(err);
      alert('Failed to add product. Please try again.');
    } finally {
      button.disabled = false;
      button.textContent = 'Add';
    }
  }
});